var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_81",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_81)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7078 10.2077C25.7078 13.2251 23.3048 15.6712 20.3405 15.6712C17.3761 15.6712 14.973 13.2251 14.973 10.2077C14.973 7.19023 17.3761 4.74414 20.3405 4.74414C23.3048 4.74414 25.7078 7.19023 25.7078 10.2077ZM12.6385 10.2251C12.6385 9.59023 12.7179 8.97278 12.8674 8.38281C12.9558 8.03375 12.7998 7.65457 12.4546 7.55213C12.035 7.42761 11.5911 7.36083 11.132 7.36083C8.52671 7.36083 6.41471 9.51063 6.41471 12.1625C6.41471 14.8144 8.52671 16.9643 11.132 16.9643C12.3139 16.9643 13.3943 16.5217 14.222 15.7907C14.4905 15.5536 14.476 15.1465 14.2532 14.866C13.2412 13.5921 12.6385 11.9745 12.6385 10.2251ZM20.3406 18.0004C23.791 17.8704 30.5769 20.4656 30.1168 26.0852C29.9634 27.0217 29.2861 27.2559 28.9666 27.2559L11.7143 27.256C11.3948 27.256 10.7174 27.0217 10.5641 26.0852C10.104 20.4656 16.8901 17.8704 20.3406 18.0004ZM10.7218 19.8479C9.36157 21.1739 8.04706 22.9055 8.23595 25.2128L8.24233 25.2907L8.25497 25.3679C8.28019 25.522 8.3129 25.6688 8.35226 25.8085C8.52089 26.4071 8.11873 27.256 7.4969 27.256H3.55062C3.26982 27.256 2.67455 27.0503 2.53977 26.2271C2.19125 21.9699 6.89886 19.5929 10.4323 19.1692C10.8143 19.1235 10.9972 19.5792 10.7218 19.8479Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_81)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.330078,
    width: 32,
    height: 32,
    fill: "#192852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.330078)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomersIcon);
export default __webpack_public_path__ + "static/media/customers-icon.00b9c0c513b3769f7012f0786c8c9536.svg";
export { ForwardRef as ReactComponent };